// Initialize DataDog RUM Monitoring - Must be first!
import 'lib/browserMonitoring/datadogPolyfill' // Polyfill to ensure DD_RUM is available early
import 'lib/browserMonitoring/initialize' // Standard Datadog RUM initialization
import 'lib/browserMonitoring/initializeAds' // Ad-specific Datadog functionality

import './shoplist-app/shopping/bundle.scss'
import 'marketing-components/dist/components/organisms/header/less/header.less'
import 'marketing-components/dist/components/organisms/footer/less/footer.less'
import { initMetricsCapture } from './lib/initMetrics'
import { Page } from './lib/types/metric'
import { initA11yLinting } from 'lib/initA11yLinting'

// @ts-ignore
__webpack_public_path__ = window.webpackPublicPath
window.addEventListener('load', () => {
  require('./views/Shopping')
})

initMetricsCapture({ page: Page.Hub })
initA11yLinting()
